import React, { forwardRef } from 'react';
import Btn from 'components/Btn';
import { withTranslation } from 'react-i18next';
import { Menu } from 'assets/icons';
import ClickAwayComponent from 'components/ClickAwayComponent';


export default withTranslation()(function TableActionBtn({ data }) {

  return (
    <ClickAwayComponent
      Component={forwardRef(({ handleClick, open }, ref) => <div className="relative" ref={ref}>
        <Btn
          classList="w-[100%] h-10 rounded-full overflow-hidden"
          content={() => <Menu classList="h-5 w-5 rotate-90" />}
          click={handleClick}
        />
        {
          open && (
            <ul className={`w-[fit-content] text-[10px] z-10 absolute border -right-1 shadow-md bg-white rounded-md`}>
              {
                data.map(({ Content, action, disabled }, index) => {
                  return (
                    <li className={`w-[150px] h-[30px] rounded-md relative flex items-center ${Content.classList}`} key={index.toString()}>
                      <Btn
                        variant={'standard'} className="w-[100%] py-3 rounded-[0]"
                        content={() => <div className={`flex absolute left-1 w-[100%] items-center ${Content.classList ?? 'text-primary'}`}>
                          {
                            Content.icon ? (() => {
                              const IconComponent = Content.icon;
                              return <IconComponent className={`${Content.classes} w-4 h-4`} />;
                            })() : null
                          }
                          <div className="w-[auto] pl-1 block">{Content.text}</div>
                        </div>
                        }
                        click={action}
                        disabled={disabled}
                      />
                    </li>
                  )
                })
              }
            </ul>
          )
        }
      </div>)
      }
    />
  )
})
